import { createUseStyles } from "react-jss";
import { breakpoints } from "../../../constants/breakpoints";
import { colors } from "../../../constants/colors";
import checkIcon from "../../../resources/images/check-blue.svg";

const styles = createUseStyles(theme => ({
  changePaymentModal: {
    width: "480px",
    "& .modal-header": {
      padding: "24px 24px 20px",
      "& div": {
        height: "46px",
        padding: "10px",
        "& svg": {
          display: "flex"
        }
      },
      "& button": {
        fontSize: "14px",
        position: "absolute",
        top: "32px",
        right: "32px"
      }
    },
    "& .modal-title": {
      padding: "0 24px"
    },
    "& .modal-body": {
      padding: "8px 24px",
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px"
    },
    "& .modal-footer": {
      padding: "24px 24px"
    },
    "& .modal-footer>*": {
      margin: "0px"
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "auto"
    }
  },
  modalContent: {
    margin: "20px 0 0 0",
    display: "grid",
    gap: "20px"
  },
  scrollableContainer: {
    maxHeight: "280px",
    overflowY: "scroll"
  },
  optionContainer:{
    cursor: "pointer",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    border: "1px solid " + colors.lightGrey,
    borderRadius: "12px",
    padding: "16px",
    marginBottom:"12px",
    "&:hover": {
      border: theme.modal.optionHover.border,
      "& input[type=\"checkbox\"]":{
        backgroundColor: theme.modal.optionHover.backgroundColor,
        border: "1px solid " + colors.darkBlue,
      },
      "& input[type=\"radio\"]":{
        backgroundColor: theme.modal.optionHover.backgroundColor,
        border: theme.buttons.primary.border,
        "&:checked": {
          backgroundColor: theme.modal.backgroundColor,
          border: theme.modal.border,
          outline: theme.buttons.primary.border,
          borderColor: theme.modal.optionHover.backgroundColor
        }
      },
    },
    "& h3":{
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "20px",
      color: colors.grey,
      margin: 0
    },
    "& p":{
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
      color: colors.mediumGrey,
      margin: "0px"
    },
    "& input":{
      appearance: "none",
      width: "16px",
      height: "16px",
      border: "1px solid " + colors.lightGrey,
      cursor: "pointer",
    },
    "& input[type=\"radio\"]":{
      borderRadius: "8px",
      "&:checked": {
        backgroundColor: theme.modal.backgroundColor,
        border: theme.modal.border,
        outline: theme.buttons.primary.border,
        backgroundImage: "none",
      }
    },
    "& input[type=\"checkbox\"]":{
      borderRadius: "4px",
      "&:checked": {
        border: "1px solid " + colors.darkBlue,
        backgroundColor: colors.white,
        backgroundImage: `url(${checkIcon})`,
        backgroundSize: "10px 10px",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundOrigin:"content-box",
      }
    },
  },
  disabledContainer: {
    backgroundColor: colors.brightBlue,
    cursor: "not-allowed",
    "&:hover": {
      border: "1px solid" + colors.gray100,
      "& input[type=\"checkbox\"]":{
        backgroundColor: "inherit",
        border: "1px solid " + colors.gray100,
      },
      "& input[type=\"radio\"]":{
        backgroundColor: colors.brightBlue,
        border: "1px solid" + colors.lightGrey,
      },
    },
  },
  selectedOptionContainer:{
    border: theme.modal.selectedOption.border,
    backgroundColor: theme.modal.selectedOption.backgroundColor,
    color: theme.modal.selectedOption.text.color,
    padding: "15px",
    "&:hover": {
      border: theme.modal.selectedOption.border,
    },
    "& h3":{
      color: theme.modal.selectedOption.text.color
    },
    "& p":{
      color: theme.modal.selectedOption.text.color
    },
  },
  expiryText: {
    "& div": {
      color: colors.darkBlue
    },
  },
  cardExpiredStyling: {
    backgroundColor: colors.gray100,
    pointerEvents: "none"
  },
  inputDisabledStyle: {
    pointerEvents: "none"
  },
  linkContainer: {
    "& a": {
      textDecoration: "none",
      color: theme.buttons.defaultLink.color,
      fontWeight: 600
    }
  },
  cardContainer: {
    display: "flex",
    gap: "12px",
    alignItems: "center",
  },
  cardIcon: {
    overflow: "visible !important"
  },
  cardDetails: {
    display: "flex",
    flexDirection: "column",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "20px",
    overflow: "hidden !important",
  },
  cardNumberText: {
    color: colors.lightBlack
  },
  cancelBtnCol:{
    height: "44px"
  },
  cancelBtn: {
    padding: "10px 0px",
    display: "flex",
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "24px",
    height: "100%",
    alignItems: "center",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "97%"
    },
  },
  saveButtonCol:{
    display: "flex",
    justifyContent: "flex-end",
    height: "44px"
  },
  saveBtn: {
    padding: "10px 0px",
    display: "flex",
    justifyContent: "center",
    textAlign: "center",
    color: colors.white,
    borderRadius: "8px",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "24px",
    width: "100%",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "97%"
    }
  },
  modalContentNoPayments: {
    margin: "20px 0 0 0",
    display: "grid",
    gap: "8px"
  },
}));

export default styles;
